export const ActionTypeChoices = {
  AUTH_LOGIN_SUCCESS: 'AUTH_LOGIN_SUCCESS',
  AUTH_LOGIN_FAILURE: 'AUTH_LOGIN_FAILURE',
  AUTH_LOGOUT: 'AUTH_LOGOUT',
  AUTH_PASSWORD_RESET_REQUEST: 'AUTH_PASSWORD_RESET_REQUEST',
  AUTH_PASSWORD_RESET_COMPLETE: 'AUTH_PASSWORD_RESET_COMPLETE',

  SEARCH_BY_PATIENT: 'SEARCH_BY_PATIENT',
  SEARCH_BY_STUDY: 'SEARCH_BY_STUDY',

  PAGE_VIEW_HOMEPAGE: 'PAGE_VIEW_HOMEPAGE',
  PAGE_VIEW_WORKSHEET: 'PAGE_VIEW_WORKSHEET',
  PAGE_VIEW_REPORT: 'PAGE_VIEW_REPORT',
  PAGE_VIEW_SETTINGS: 'PAGE_VIEW_SETTINGS',

  WORKSHEET_MEASUREMENT_EDITED: 'WORKSHEET_MEASUREMENT_EDITED',
  WORKSHEET_FINDING_EDITED: 'WORKSHEET_FINDING_EDITED',
  WORKSHEET_FLAG_ADDED: 'WORKSHEET_FLAG_ADDED',
  WORKSHEET_FLAG_REMOVED: 'WORKSHEET_FLAG_REMOVED',
  WORKSHEET_REPORT_SAVED: 'WORKSHEET_REPORT_SAVED',
  WORKSHEET_REPORT_FINALIZED: 'WORKSHEET_REPORT_FINALIZED',
  WORKSHEET_ADDENDUM_CREATED: 'WORKSHEET_ADDENDUM_CREATED',

  REPORT_PDF_DOWNLOADED: 'REPORT_PDF_DOWNLOADED',

  AUDIT_LOG_EXPORTED: 'AUDIT_LOG_EXPORTED',
  STUDY_ACCESS_DENIED: 'STUDY_ACCESS_DENIED',

  PAGE_VIEW_PATIENT: 'PAGE_VIEW_PATIENT',

  PATIENT_CREATED: 'PATIENT_CREATED',
  PATIENT_MERGED: 'PATIENT_MERGED',
} as const;

export type ActionType =
  (typeof ActionTypeChoices)[keyof typeof ActionTypeChoices];

export const ObjectTypeChoices = {
  USER: 'USER',
  PATIENT: 'PATIENT',
  STUDY: 'STUDY',
  REPORT: 'REPORT',
  ADDENDUM: 'ADDENDUM',
  MEASUREMENT: 'MEASUREMENT',
  FINDING: 'FINDING',
  FLAG: 'FLAG',
  CONCLUSION: 'CONCLUSION',
  SIGNATURE: 'SIGNATURE',
} as const;

export type ObjectType =
  (typeof ObjectTypeChoices)[keyof typeof ObjectTypeChoices];

export interface LogItem {
  actionType: ActionType | null;
  createdAt: string;
  context: Record<string, unknown> | null;
  ipAddress: string | null;
  objectType: ObjectType | null;
  objectId: string | null;
  userId: string | null;
  userFirstName: string | null;
  userLastName: string | null;
  userRole: string | null;
  uuid: string;
}

export interface LogItemParams {
  actionType?: ActionType | ActionType[];
  objectType?: ObjectType;
  objectId?: string;
  createdAtAfter?: string;
  createdAtBefore?: string;
  userId?: string;
  page?: number;
  size?: number;
}
